import * as React from 'react';
import { ItemFieldProps } from './types';
import { Metadata } from '../../../../types/Metadata';
import { useSelector } from '../../../../utils/useSelector';
import { NodeType } from '../../../../enums/NodeType';
import { Field } from './field';

export const TaskPendingKIsField = (f: ItemFieldProps) => {
  const empCd = useSelector(
    s => s.view?.backingUpFor?.empCd || s.app?.user?.employeeId
  );
  const { item } = f;
  const fieldInfo = f.fieldInfo;
  const additionalKIs: Metadata[] = item.props?.additionalKeyInitiatives;
  if (!additionalKIs?.length) return null;
  const kiIds = item.props?.taskPendingKIs
    ?.filter(f => f?.empCd == empCd)
    .map(f => f.kiId);
  if (!kiIds?.length) return null;
  const pendingKIs = additionalKIs.filter(m => kiIds.includes(m?.props?.id));
  if (!pendingKIs.length) return null;
  const field = 'Additional Key Initiatives';

  return pendingKIs.map((m: Metadata) => (
    <Field
      key={m.id}
      labels={[NodeType.KeyInitiative]}
      values={[m.props.name]}
      fieldInfo={fieldInfo}
    />
  ));
};
